import classNames from 'classnames';
import Button from 'components/ui/Button';
import { FC, RefObject } from 'react';
import styles from './index.module.scss';

interface Props {
  id?: string;
  className?: string;
  disabled?: boolean;
  href?: string;
  icon: React.JSX.Element;
  buttonRef?: RefObject<any>;
  isExternal?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
const IconButton: FC<Props> = ({
  className,
  href,
  icon,
  disabled = false,
  onClick,
  id,
  isExternal,
  buttonRef,
}) => {
  return (
    <Button
      buttonRef={buttonRef}
      id={id}
      onClick={onClick}
      disabled={disabled}
      href={href}
      isExternalHref={isExternal}
      className={classNames(styles.root, className)}
      styleType={['icon']}
      altStyleType={['icon']}>
      {icon}
    </Button>
  );
};

export default IconButton;
